import { SelectContextProvider } from './providers/SelectContext';
import type { DialogComboboxProps } from '../DialogCombobox';
import { DialogCombobox } from '../DialogCombobox';

export interface SelectV2Props extends Omit<DialogComboboxProps, 'multiselect' | 'value'> {
  placeholder?: string;
  value?: string;
}

export const SelectV2 = (props: SelectV2Props) => {
  const { children, placeholder, value, ...restProps } = props;

  return (
    <SelectContextProvider value={{ isSelect: true, placeholder }}>
      <DialogCombobox value={value ? [value] : []} {...restProps}>
        {children}
      </DialogCombobox>
    </SelectContextProvider>
  );
};
